import React from 'react';
import {
  Button,
  ButtonGroup,
  DropdownButton,
  Modal,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';
import { Link } from 'react-router-dom';

import { Table, Customer } from 'services/action';
import CustomerForm from './form';

const initialState = {
  privilege: null,
  isShow: false,
  isUpdate: false,
};

const URL = `${process.env.REACT_APP_TMS_SYSTEM_URL}`;

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const Session = useSelector((state) => state.Auth?.session);
  const StateTable = useSelector((state) => state?.Table?.data['customer']);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Customer.Delete']
  );
  const textCopierRef = React.useRef(null);

  const [{ privilege, isShow, isUpdate }, setState] =
    React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.partner',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  const copyConnect = () => {
    textCopierRef.current.select();
    document.execCommand('copy');
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      isShow: false,
      isUpdate: false,
      isDefault: false,
    }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Customer.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('customer', StateTable));
    }
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    return (
      <div className="row">
        <DropdownButton
          as={ButtonGroup}
          variant="transparent"
          size="md"
          className="no-carret tbl-action"
          title={<Fi.FiMoreVertical size={13} color="gray" />}
        >
          {data?.partner_id === '' && (
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() => copyConnect()}
            >
              <Fi.FiPaperclip size={15} color="#202020" className="me-2" />
              <textarea
                ref={textCopierRef}
                style={{
                  height: 0,
                  width: 0,
                  resize: 'none',
                  position: 'absolute',
                  top: -1000,
                }}
                readOnly
                value={`${URL}/connect/${data?.id}`}
              />
              Copy Link Connect
            </button>
          )}

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isUpdate: true }))
            }
          >
            <Fi.FiEdit size={15} color="#202020" className="me-2" />
            Perbaharui
          </button>

          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isShow: true }))
            }
          >
            <Fi.FiTrash2 size={15} className="me-2" />
            Hapus
          </button>
        </DropdownButton>

        {/* modal delete */}
        <Modal
          show={isShow}
          onHide={$handleClose}
          backdrop="static"
          centered
          className="text-center"
          size="small"
        >
          <Modal.Body>
            <div className="btn-close" onClick={$handleClose} />
            <div className="modal-status bg-danger" />
            <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
            <h3>Anda yakin?</h3>
            <p className="text-danger fw-semibold">
              Data yang sudah dihapus tidak bisa dipulihkan
            </p>
          </Modal.Body>
          <Modal.Footer>
            <div className="row w-100">
              <div className="col">
                <Button
                  variant="white"
                  className="w-100"
                  onClick={$handleClose}
                >
                  Batal
                </Button>
              </div>
              <div className="col">
                <Button
                  variant="danger"
                  className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                  onClick={$handleDelete}
                  disabled={StateLoading}
                >
                  Hapus
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={isUpdate}
          onHide={$handleClose}
          backdrop="static"
          centered
          size="md"
          enforceFocus={true}
        >
          <Modal.Header closeButton>
            <Modal.Title>Perbaharui Customer</Modal.Title>
          </Modal.Header>
          <CustomerForm onClose={$handleClose} data={data} />
        </Modal>
      </div>
    );
  }

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id={`tooltip-top`}>Detil</Tooltip>}
    >
      <Link
        className="btn btn-light px-2"
        role="button"
        to={`/master/customer/${data?.id}`}
      >
        <Fi.FiArrowRight />
      </Link>
    </OverlayTrigger>
  );
};

export default Action;
